/* assets/vijvercheck-history-v3.js
 * VijverCheck Historie dashboard v3 (GOAT-redesign)
 * - 4 KPI hero cards (count, eerste, laatste, streak)
 * - 7 Chart.js line charts (pH, KH, GH, NO2, NO3, NH4, O2)
 * - Threshold-bands per parameter (groen/geel/oranje/rood)
 * - Tijdvenster filter: 30/90/365/alles
 * - Collapsible tabel met delete-rij
 * - Lazy-loads Chart.js plus annotation-plugin van CDN met fallback
 * - Data: /apps/vp/metingen (App Proxy naar business.retailz.io) als je ingelogd bent,
 *   anders vw_metingen_v1 op dit apparaat; na inloggen gaan die rijen vanzelf mee.
 * - Brand: aqua/navy/koi, geen em/en-dash, comma als separator.
 */
(function(){
  'use strict';

  var ROOT = document.getElementById('vw-historie-v3');
  if (!ROOT) return;

  var CUSTOMER_ID = (ROOT.getAttribute('data-customer-id') || '').trim();
  // 18-10-2026 (fase 2 omschakelplan, B-2026-10-18-3): same-origin via de Shopify App Proxy
  // naar business.retailz.io. Geen e-mailadres meer in de pagina of in de URL.
  var METINGEN_URL  = '/apps/vp/metingen';
  var VERWIJDER_URL = '/apps/vp/metingen/verwijder';

  var CDN_CHART   = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.3/dist/chart.umd.min.js';
  var CDN_DFNS    = 'https://cdn.jsdelivr.net/npm/date-fns@3.6.0/+esm';
  var CDN_ADAPTER = 'https://cdn.jsdelivr.net/npm/chartjs-adapter-date-fns@3.0.0/dist/chartjs-adapter-date-fns.bundle.min.js';
  var CDN_ANNOT   = 'https://cdn.jsdelivr.net/npm/chartjs-plugin-annotation@3.0.1/dist/chartjs-plugin-annotation.min.js';

  // Threshold-config per parameter
  // Statusbanden per parameter (ok = OK, warn = Let op, danger = Ingrijpen, daarbuiten = Crisis).
  // Gelijkgetrokken met de hints op de advies-tab op 16-10-2026 (akkoord Kees: "onderzoeken
  // met een goede bron"). Bronnen: Merck Veterinary Manual, Environmental Diseases of Aquatic
  // Animals, tabel Normal Reference Ranges (review 05-2023, bijgewerkt 06-2026); Saint-Erne en
  // Tepper, Performing Water Tests, WSAVA Congress 2019 (koi); Penn State Extension, Water
  // Quality Concerns for Ponds (09-2025); OECD 1982 eutrofieringsgrenzen. 1 dH = 17,848 mg/L CaCO3.
  //  pH   : koi 7,0-8,5; zoetwater 6,5-9,0 (Merck); extreem onder 5,5 of boven 9,5 (Saint-Erne; Merck letaal rond 4 en 10).
  //  KH   : alkaliniteit 100-250 mg/L = 6-14 dKH (Merck, Saint-Erne); onder 50 mg/L = 3 dKH geen buffer (Merck).
  //  GH   : koi 100-250 mg/L = 6-14 dGH (Saint-Erne); onder 20 mg/L = 1 dGH mineraaltekort (Merck).
  //  NO2  : hoort 0; boven 0,1 giftig (Merck). Banden daarboven volgen de adviesmotor (W013 0,2-1, W014 vanaf 1).
  //  NO3  : onder 20 (Merck, Saint-Erne); verversen boven 20, tot 100 kortdurend verdragen (Saint-Erne); motor W008 boven 50, W015 boven 100.
  //  PO4  : onder 0,1 mg/L = onder 35 ug/L fosfor, de eutrofieringsgrens (OECD 1982); 0,5 mg/L en hoger is hypertroof (100 ug/L P); motor W028 boven 0,5.
  //  NH4  : hoort 0; boven 0,25 filterprobleem (Saint-Erne); zoetwatervis verdraagt tot 1 mg/L totaal ammoniak (Merck); motor C001 vanaf 1.
  //  O2   : boven 6 gezond (Penn State); onder 5 stress, 4 of lager sterfte mogelijk (Merck); motor W006 bij 3 of lager.
  var THRESHOLDS = {
    pH:             { unit: '',      label: 'pH',           min:5.0, max:10.0, ok:[7.0,8.5],  warn:[6.5,9.0],  danger:[5.5,9.5], dynamic:false },
    KH_dkh:         { unit: 'dKH',   label: 'KH',           min:0,   max:20,   ok:[6,14],     warn:[3,15],     danger:[2,18],    dynamic:false },
    GH_dkh:         { unit: 'dGH',   label: 'GH',           min:0,   max:24,   ok:[6,14],     warn:[4,20],     danger:[1,24],    dynamic:false },
    NO2_mg_l:       { unit: 'mg/L',  label: 'Nitriet NO2',  min:0,   max:1,    ok:[0,0.1],    warn:[0.1,0.2],  danger:[0.2,1.0], dynamic:true },
    NO3_mg_l:       { unit: 'mg/L',  label: 'Nitraat NO3',  min:0,   max:200,  ok:[0,20],     warn:[20,50],    danger:[50,100],  dynamic:true },
    PO4_mg_l:       { unit: 'mg/L',  label: 'Fosfaat PO4',  min:0,   max:10,   ok:[0,0.1],    warn:[0.1,0.5],  danger:[0.5,2.0], dynamic:true },
    NH4_total_mg_l: { unit: 'mg/L',  label: 'Ammonium NH4', min:0,   max:1,    ok:[0,0.25],   warn:[0.25,0.5], danger:[0.5,1.0], dynamic:true },
    O2_mg_l:        { unit: 'mg/L',  label: 'Zuurstof O2',  min:0,   max:14,   ok:[6,14],     warn:[5,6],      danger:[3,5],     dynamic:false }
  };
  var PARAM_ORDER = ['pH','KH_dkh','GH_dkh','NO2_mg_l','NO3_mg_l','PO4_mg_l','NH4_total_mg_l','O2_mg_l'];

  // Brand colors (Tailwind tokens approximation)
  var COL = {
    aqua: '#0EA5B7',
    navy: '#0B1E36',
    koi:  '#F26B1F',
    okBg:     'rgba(34,197,94,0.10)',
    warnBg:   'rgba(250,204,21,0.12)',
    dangerBg: 'rgba(249,115,22,0.14)',
    crisisBg: 'rgba(239,68,68,0.14)'
  };

  // 31-08-2026: lokale modus. Wie niet is ingelogd bewaart in localStorage
  // (vw_metingen_v1, geschreven door vijvercheck-save.js). Die rijen werden
  // door NIETS teruggelezen, terwijl de bewaarknop belooft dat je bij je
  // volgende meting het verloop ziet. Hier lossen we die belofte in.
  var LOKAAL_KEY  = 'vw_metingen_v1';
  var MEAS_FIELDS = ['pH','KH_dkh','GH_dkh','NO2_mg_l','NO3_mg_l','PO4_mg_l','NH4_total_mg_l','O2_mg_l'];
  var lokaalModus = false;

  var state = {
    measurements: [],
    filtered: [],
    range: 'all',
    charts: {},
    chartLibReady: false
  };

  // -------- Helpers
  function $(sel, root){ return (root||ROOT).querySelector(sel); }
  function $all(sel, root){ return Array.prototype.slice.call((root||ROOT).querySelectorAll(sel)); }
  function show(el){ if (el) el.hidden = false; }
  function hide(el){ if (el) el.hidden = true; }
  function escapeHtml(s){
    return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function fmtDateShort(iso){
    if (!iso) return '';
    try { var d = new Date(iso); return d.toLocaleDateString('nl-NL',{day:'2-digit',month:'short'}); }
    catch(_){ return iso; }
  }
  function fmtDateLong(iso){
    if (!iso) return '';
    try {
      var d = new Date(iso);
      return d.toLocaleDateString('nl-NL',{day:'2-digit',month:'short',year:'numeric'}) +
             ', ' + d.toLocaleTimeString('nl-NL',{hour:'2-digit',minute:'2-digit'});
    } catch(_){ return iso; }
  }
  function fmtNum(v){
    if (v == null || v === '' || isNaN(v)) return ',';
    return (Math.round(v*100)/100).toString().replace('.', ',');
  }
  function statusFor(param, v){
    if (v == null) return 'unknown';
    var t = THRESHOLDS[param]; if (!t) return 'unknown';
    if (v >= t.ok[0] && v <= t.ok[1]) return 'ok';
    if (v >= t.warn[0] && v <= t.warn[1]) return 'warn';
    if (v >= t.danger[0] && v <= t.danger[1]) return 'danger';
    return 'crisis';
  }
  function statusLabel(s){
    if (s === 'ok') return 'OK';
    if (s === 'warn') return 'Let op';
    if (s === 'danger') return 'Ingrijpen';
    if (s === 'crisis') return 'Crisis';
    return 'Onbekend';
  }

  // -------- Script loader
  function loadScript(src){
    return new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src; s.async = true; s.defer = true;
      s.onload = function(){ resolve(); };
      s.onerror = function(){ reject(new Error('load failed: ' + src)); };
      document.head.appendChild(s);
    });
  }
  function ensureChartLib(){
    if (state.chartLibReady) return Promise.resolve(true);
    if (window.Chart) { state.chartLibReady = true; return Promise.resolve(true); }
    return loadScript(CDN_CHART)
      .then(function(){ return loadScript(CDN_ADAPTER).catch(function(){ /* date-adapter required for time-scale */ }); })
      .then(function(){ return loadScript(CDN_ANNOT).catch(function(){ /* annotation optional */ }); })
      .then(function(){
        if (window.Chart && window.Chart.register && window['chartjs-plugin-annotation']){
          try { window.Chart.register(window['chartjs-plugin-annotation']); } catch(_){}
        }
        state.chartLibReady = true; return true;
      })
      .catch(function(e){
        console.warn('[vw-hist-v3] chart-lib niet beschikbaar:', e && e.message);
        state.chartLibReady = false; state.chartLibFailed = true; return false;
      });
  }

  // -------- Data
  // 18-10-2026: lezen en wissen via /apps/vp/metingen (contract: app.retailz.io.v2
  // platform/customer-data/src/vijver-ingang.ts). De klant komt uit de handtekening van
  // Shopify. Zonder geldige sessie geeft de ingang 401 (`niet-ingelogd`).
  function leesAntwoord(r){
    return r.json().catch(function(){ return null; }).then(function(b){ return { ok: r.ok, status: r.status, body: b }; });
  }
  function laadVanAccount(){
    return fetch(METINGEN_URL, { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(leesAntwoord)
      .then(function(res){
        if (!res.ok || !res.body || res.body.ok !== true){
          var e = new Error('HTTP ' + res.status);
          e.status = res.status;
          throw e;
        }
        return Array.isArray(res.body.measurements) ? res.body.measurements : [];
      });
  }

  // 16-10-2026 (melding Kees: "de flow moet frictieloos zijn"), sinds 18-10-2026 zonder
  // e-mailadres: wie ingelogd is en nog metingen op dit apparaat heeft staan (vw_metingen_v1,
  // bewaard voor het inloggen), krijgt die vanzelf in het account. vwKoppelLokaal komt uit
  // vijvercheck-save.js; dubbelen tegen de accountrijen worden daar overgeslagen en
  // overgezette rijen lokaal gemarkeerd.
  function koppelLokaalNaarAccount(rows){
    var lokaal = (typeof window.vwLokaleMetingen === 'function') ? window.vwLokaleMetingen() : [];
    var open = lokaal.filter(function(m){ return m && m.measured_at && !m.gekoppeld; });
    if (!open.length || typeof window.vwKoppelLokaal !== 'function') return Promise.resolve(null);
    return window.vwKoppelLokaal({ bestaand: rows }).catch(function(){ return null; });
  }
  function toonGekoppeld(uit){
    var box = document.getElementById('vw-hist-v3-gekoppeld');
    if (!box) return;
    var n = (uit && uit.geupload) || 0;
    var rest = (uit && uit.fouten > 0 && uit.resterend) || 0;
    var delen = [];
    if (n > 0) delen.push(n + (n === 1 ? ' meting' : ' metingen') + ' van dit apparaat ' + (n === 1 ? 'is' : 'zijn') + ' aan je account toegevoegd.');
    if (rest > 0) delen.push(rest + (rest === 1 ? ' meting kon' : ' metingen konden') + ' nog niet worden toegevoegd; dat proberen we bij je volgende bezoek vanzelf opnieuw.');
    if (!delen.length){ hide(box); return; }
    var groen = n > 0;
    ['border-green-200','bg-green-50','text-green-800'].forEach(function(c){ box.classList.toggle(c, groen); });
    ['border-amber-200','bg-amber-50','text-amber-800'].forEach(function(c){ box.classList.toggle(c, !groen); });
    var span = box.querySelector('span');
    if (span) span.textContent = delen.join(' ');
    show(box);
  }

  function fetchData(){
    if (!CUSTOMER_ID){ return loadLocal(); }
    lokaalModus = false;
    hide(document.getElementById('vw-hist-v3-lokaal'));
    return laadVanAccount()
      .then(function(rows){
        return koppelLokaalNaarAccount(rows).then(function(uit){
          if (uit) toonGekoppeld(uit);
          if (uit && uit.geupload > 0) return laadVanAccount();
          return rows;
        });
      })
      .then(function(rows){
        hide(document.getElementById('vw-hist-v3-error'));
        state.measurements = rows || [];
        // Sort ascending by measured_at (oudste eerst voor charts)
        state.measurements.sort(function(a,b){
          return new Date(a.measured_at) - new Date(b.measured_at);
        });
        applyRangeFilter();
        renderAll();
      })
      .catch(function(e){
        console.warn('[vw-hist-v3] fetch fout:', e && e.message);
        if (e && e.status === 401){
          // De winkel ziet je als ingelogd, de App Proxy niet (sessie verlopen). Geen strook
          // "alleen op dit apparaat", wel een duidelijke weg terug.
          renderLoginFout();
          return;
        }
        renderError('Kon historie niet laden, probeer verversen.');
      });
  }

  // Leest de lokaal bewaarde metingen en zet ze in dezelfde vorm als de
  // proxy-rijen, zodat KPIs, grafieken en tabel ongewijzigd werken.
  function loadLocal(){
    lokaalModus = true;
    var lijst = [];
    try {
      var l = JSON.parse(localStorage.getItem(LOKAAL_KEY) || '[]');
      if (Array.isArray(l)) lijst = l;
    } catch(_){ lijst = []; }

    state.measurements = lijst.map(function(m){
      var meas = (m && m.measurements && typeof m.measurements === 'object') ? m.measurements : {};
      var pond = (m && m.pond && typeof m.pond === 'object') ? m.pond : {};
      var row = {
        id: 'lokaal|' + ((m && (m.id || m.measured_at)) || ''),
        measured_at: m && m.measured_at,
        postcode: (m && m.postcode) || null,
        depth_cm: pond.depth_cm != null ? pond.depth_cm : null,
        volume_l: pond.volume_l != null ? pond.volume_l : null
      };
      MEAS_FIELDS.forEach(function(f){
        var v = meas[f];
        row[f] = (v === '' || v === undefined) ? null : v;
      });
      return row;
    }).filter(function(r){ return !!r.measured_at; });

    state.measurements.sort(function(a,b){
      return new Date(a.measured_at) - new Date(b.measured_at);
    });

    var strook = document.getElementById('vw-hist-v3-lokaal');
    if (state.measurements.length) show(strook); else hide(strook);
    // Stap in de strook: alleen op dit apparaat (met loginlink), of al eerder in het account gezet.
    var allesGekoppeld = lijst.length > 0 && lijst.every(function(m){ return m && m.gekoppeld; });
    toonLokaalStap(allesGekoppeld ? 'gekoppeld' : 'lokaal');

    applyRangeFilter();
    renderAll();
  }

  function applyRangeFilter(){
    var r = state.range;
    if (r === 'all'){ state.filtered = state.measurements.slice(); return; }
    var days = parseInt(r, 10);
    var cutoff = Date.now() - days*24*60*60*1000;
    state.filtered = state.measurements.filter(function(m){
      return new Date(m.measured_at).getTime() >= cutoff;
    });
  }

  // -------- KPI berekening
  function computeStreak(){
    if (!state.measurements.length) return 0;
    // Streak = weken op rij waarin tenminste 1 meting is.
    var weeks = {};
    state.measurements.forEach(function(m){
      var d = new Date(m.measured_at);
      // ISO week-key: year + week-number (simpel: dayOfYear / 7)
      var start = new Date(d.getFullYear(),0,1);
      var dow = Math.floor((d - start) / 86400000);
      var wk = d.getFullYear() + '-' + Math.floor(dow/7);
      weeks[wk] = true;
    });
    var keys = Object.keys(weeks).sort().reverse();
    if (!keys.length) return 0;
    // Pak de laatste week-key en tel terug
    var now = new Date();
    var startNow = new Date(now.getFullYear(),0,1);
    var dowNow = Math.floor((now - startNow) / 86400000);
    var curYear = now.getFullYear();
    var curWeek = Math.floor(dowNow/7);
    var streak = 0;
    while (true){
      var key = curYear + '-' + curWeek;
      if (weeks[key]){ streak++; curWeek--; if (curWeek < 0){ curYear--; curWeek = 51; } }
      else break;
    }
    return streak;
  }

  function renderKPIs(){
    var box = document.getElementById('vw-hist-v3-kpis');
    if (!box) return;
    var n = state.measurements.length;
    var first = n ? fmtDateShort(state.measurements[0].measured_at) : ',';
    var last  = n ? fmtDateShort(state.measurements[n-1].measured_at) : ',';
    var streak = computeStreak();

    function card(label, value, sub, icon){
      return '<div class="bg-white border border-slate-200 rounded-xl p-3 sm:p-4 flex flex-col gap-1">' +
        '<div class="flex items-center gap-2 text-[11px] uppercase tracking-wide text-slate-500 font-semibold">' +
        '<span class="inline-flex items-center justify-center w-6 h-6 rounded-md bg-aqua/10 text-aqua-donker">' + icon + '</span>' +
        escapeHtml(label) + '</div>' +
        '<div class="font-display font-bold text-xl sm:text-2xl text-navy tabular-nums">' + escapeHtml(value) + '</div>' +
        (sub ? '<div class="text-[11px] text-slate-500">' + escapeHtml(sub) + '</div>' : '') +
      '</div>';
    }
    var icMeas   = '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 14l4-4 4 4 5-5"/></svg>';
    var icCal    = '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>';
    var icClock  = '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
    var icFire   = '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 17c1 0 1.7-.5 2.5-1.5 1.3-1.7 0-3.2.5-5 .3-1 1.5-2 1.5-2-.5 4 2.5 5 2.5 8a6 6 0 1 1-12 0c0-2 1-3.5 2.5-5 .5 1 .5 2 0 3z"/></svg>';

    box.className = 'grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-5 px-3 sm:px-0';
    box.innerHTML =
      card('Aantal metingen', String(n), n === 1 ? 'meting opgeslagen' : 'metingen opgeslagen', icMeas) +
      card('Eerste meting', first, n ? 'sinds je start' : '-', icCal) +
      card('Laatste meting', last, n ? 'meest recent' : '-', icClock) +
      card('Streak', streak + (streak === 1 ? ' week' : ' weken'), streak > 0 ? 'op rij actief' : 'start je streak', icFire);
  }

  // -------- Filter bar
  function bindFilter(){
    var wrap = document.getElementById('vw-hist-v3-filter-wrap');
    if (!wrap) return;
    show(wrap);
    var btns = $all('.vw-hist-range', wrap);
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var r = b.getAttribute('data-vw-range');
        state.range = r;
        btns.forEach(function(x){
          x.classList.remove('is-active','bg-white','text-navy','shadow-sm');
          x.classList.add('text-slate-600');
          x.setAttribute('aria-selected','false');
        });
        b.classList.add('is-active','bg-white','text-navy','shadow-sm');
        b.classList.remove('text-slate-600');
        b.setAttribute('aria-selected','true');
        applyRangeFilter();
        renderCharts();
        renderTable();
      });
    });
  }

  // -------- Charts
  function destroyCharts(){
    Object.keys(state.charts).forEach(function(k){
      try { state.charts[k].destroy(); } catch(_){}
    });
    state.charts = {};
  }

  function buildAnnotations(param){
    var t = THRESHOLDS[param]; if (!t) return {};
    if (!(window.Chart && window['chartjs-plugin-annotation'])) return {};
    // Bands: crisis (buiten danger) rood; danger-tussen-warn oranje; warn-tussen-ok geel; ok groen.
    return {
      annotations: {
        bandCrisisLow: { type:'box', yMin: t.min, yMax: t.danger[0], backgroundColor: COL.crisisBg, borderWidth:0 },
        bandDangerLow: { type:'box', yMin: t.danger[0], yMax: t.warn[0], backgroundColor: COL.dangerBg, borderWidth:0 },
        bandWarnLow:   { type:'box', yMin: t.warn[0], yMax: t.ok[0], backgroundColor: COL.warnBg, borderWidth:0 },
        bandOk:        { type:'box', yMin: t.ok[0], yMax: t.ok[1], backgroundColor: COL.okBg, borderWidth:0 },
        bandWarnHigh:  { type:'box', yMin: t.ok[1], yMax: t.warn[1], backgroundColor: COL.warnBg, borderWidth:0 },
        bandDangerHigh:{ type:'box', yMin: t.warn[1], yMax: t.danger[1], backgroundColor: COL.dangerBg, borderWidth:0 },
        bandCrisisHigh:{ type:'box', yMin: t.danger[1], yMax: t.max, backgroundColor: COL.crisisBg, borderWidth:0 }
      }
    };
  }

  function makeGradient(ctx, color){
    var grd = ctx.createLinearGradient(0, 0, 0, 220);
    grd.addColorStop(0, color.replace('1)','0.35)').replace('rgb(','rgba('));
    grd.addColorStop(1, color.replace('1)','0)').replace('rgb(','rgba('));
    return grd;
  }

  function renderChartTile(param, container){
    var t = THRESHOLDS[param];
    var data = state.filtered
      .map(function(m){ return { x: m.measured_at, y: m[param] }; })
      .filter(function(d){ return d.y != null && d.y !== '' && !isNaN(d.y); });

    var tile = document.createElement('div');
    tile.className = 'bg-white border border-slate-200 rounded-xl p-3 sm:p-4 flex flex-col';
    tile.setAttribute('data-param', param);

    var lastVal = data.length ? data[data.length-1].y : null;
    var st = statusFor(param, lastVal);
    var statusDot = '<span class="inline-block w-2 h-2 rounded-full ' +
      (st==='ok'?'bg-green-500':st==='warn'?'bg-yellow-500':st==='danger'?'bg-orange-500':st==='crisis'?'bg-red-500':'bg-slate-300') +
      '"></span>';

    tile.innerHTML =
      '<div class="flex items-center justify-between mb-2 gap-2">' +
        '<div class="flex items-center gap-2 min-w-0">' +
          '<h4 class="font-semibold text-sm text-navy m-0 truncate">' + escapeHtml(t.label) + (t.unit ? ' <span class="text-slate-500 font-normal">(' + escapeHtml(t.unit) + ')</span>' : '') + '</h4>' +
        '</div>' +
        '<div class="flex items-center gap-1.5 text-xs text-slate-500">' + statusDot +
          '<span class="tabular-nums font-semibold text-navy">' + (lastVal!=null ? fmtNum(lastVal) : ',') + '</span>' +
        '</div>' +
      '</div>';

    if (data.length < 2){
      var hint = document.createElement('p');
      hint.className = 'text-xs text-slate-500 italic flex-1 flex items-center justify-center text-center min-h-[160px]';
      hint.textContent = (data.length === 0)
        ? 'Nog geen waarden ingevuld voor deze parameter.'
        : 'Vul nog 1 waarde in om een trend te zien.';
      tile.appendChild(hint);
      container.appendChild(tile);
      return;
    }

    var canvasWrap = document.createElement('div');
    canvasWrap.style.position = 'relative';
    canvasWrap.style.height = '200px';
    var canvas = document.createElement('canvas');
    canvas.id = 'vw-chart-' + param;
    canvasWrap.appendChild(canvas);
    tile.appendChild(canvasWrap);
    container.appendChild(tile);

    if (!(window.Chart)) return;

    var ctx = canvas.getContext('2d');
    var grad = ctx.createLinearGradient(0,0,0,200);
    grad.addColorStop(0, 'rgba(14,165,183,0.30)');
    grad.addColorStop(1, 'rgba(14,165,183,0.00)');

    var ann = buildAnnotations(param);
    var ySuggMin = t.dynamic ? undefined : t.min;
    var ySuggMax = t.dynamic ? undefined : t.max;

    state.charts[param] = new window.Chart(ctx, {
      type: 'line',
      data: {
        datasets: [{
          label: t.label,
          data: data,
          parsing: false,
          borderColor: COL.aqua,
          backgroundColor: grad,
          borderWidth: 2,
          fill: true,
          tension: 0.3,
          pointRadius: 0,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: COL.navy,
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 400 },
        interaction: { mode: 'nearest', intersect: false },
        scales: {
          x: {
            type: 'time',
            time: { unit: data.length < 14 ? 'day' : 'week', displayFormats: { day: 'd MMM', week: 'd MMM' } },
            grid: { display: false },
            ticks: { color: '#94a3b8', font: { size: 10 }, maxRotation: 0, autoSkipPadding: 14 }
          },
          y: {
            suggestedMin: ySuggMin,
            suggestedMax: ySuggMax,
            grid: { color: 'rgba(148,163,184,0.15)', drawBorder: false },
            ticks: { color: '#94a3b8', font: { size: 10 }, maxTicksLimit: 5 }
          }
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#0B1E36',
            titleColor: '#fff',
            bodyColor: '#fff',
            padding: 10,
            cornerRadius: 8,
            displayColors: false,
            callbacks: {
              title: function(items){ return fmtDateLong(items[0].parsed.x); },
              label: function(item){
                var v = item.parsed.y;
                var s = statusFor(param, v);
                return t.label + ': ' + fmtNum(v) + (t.unit ? ' ' + t.unit : '') + '  (' + statusLabel(s) + ')';
              }
            }
          },
          annotation: ann
        }
      }
    });
  }

  // Fall-back tile zonder Chart.js: spark-strook met laatste waarden
  function renderSparkTile(param, container){
    var t = THRESHOLDS[param];
    var data = state.filtered
      .map(function(m){ return m[param]; })
      .filter(function(v){ return v != null && v !== '' && !isNaN(v); });
    var tile = document.createElement('div');
    tile.className = 'bg-white border border-slate-200 rounded-xl p-3 sm:p-4';
    var last = data.length ? data[data.length-1] : null;
    var st = statusFor(param, last);
    tile.innerHTML =
      '<div class="flex items-center justify-between mb-2">' +
        '<h4 class="font-semibold text-sm text-navy m-0">' + escapeHtml(t.label) + (t.unit ? ' <span class="text-slate-500 font-normal">(' + escapeHtml(t.unit) + ')</span>' : '') + '</h4>' +
        '<span class="text-xs font-semibold tabular-nums text-navy">' + (last!=null?fmtNum(last):',') + '</span>' +
      '</div>' +
      '<p class="text-xs text-slate-500 m-0">' + (data.length ? data.length + ' waarden, status ' + statusLabel(st) : 'Nog geen waarden') + '</p>';
    container.appendChild(tile);
  }

  function renderCharts(){
    var holder = document.getElementById('vw-hist-v3-charts');
    if (!holder) return;
    destroyCharts();
    holder.innerHTML = '';
    var useChart = !!window.Chart;
    // 31-08-2026: parameters zonder ENKELE waarde kregen een lege kaart met
    // "Nog geen waarden ingevuld". Op een account met 4 metingen (18-07-2026)
    // gaf dat 7 lege kaarten tegen 1 gevulde, waardoor het dashboard leeg
    // oogt terwijl er wel data is. Nu tonen we alleen wat gemeten is.
    var gevuld = [], leeg = [];
    PARAM_ORDER.forEach(function(p){
      var heeft = state.measurements.some(function(m){
        var v = m[p];
        return v !== null && v !== undefined && v !== '' && !isNaN(parseFloat(v));
      });
      (heeft ? gevuld : leeg).push(p);
    });
    gevuld.forEach(function(p){
      try {
        if (useChart) renderChartTile(p, holder);
        else renderSparkTile(p, holder);
      } catch(e){
        console.warn('[vw-hist-v3] chart render fout', p, e && e.message);
        try { renderSparkTile(p, holder); } catch(_){}
      }
    });
    renderNietGemeten(leeg);
    // 16-10-2026: de fallbackmelding ("Grafieken konden niet laden") verscheen
    // ook als Chart.js gewoon nog aan het laden was en bleef daarna staan. Nu
    // alleen als het laden echt is mislukt, en weg zodra er grafieken zijn.
    var fb = document.getElementById('vw-hist-v3-chart-fallback');
    if (fb){
      if (useChart || !state.chartLibFailed) hide(fb); else show(fb);
    }
  }

  // Een regel onder de grafieken in plaats van een muur lege kaarten.
  function renderNietGemeten(leeg){
    var box = document.getElementById('vw-hist-v3-nietgemeten');
    if (!box) return;
    if (!leeg || !leeg.length || !state.measurements.length){ box.innerHTML = ''; hide(box); return; }
    var namen = leeg.map(function(p){ return (THRESHOLDS[p] && THRESHOLDS[p].label) || p; });
    box.innerHTML =
      '<p class="text-sm text-slate-600 m-0">Nog niet gemeten: ' +
      '<span class="text-navy font-semibold">' + escapeHtml(namen.join(', ')) + '</span>. ' +
      'Vul ze in bij je volgende meting, dan komen die grafieken er vanzelf bij.</p>' +
      '<button type="button" data-vw-switch-tab="advies" ' +
      'class="mt-3 inline-flex items-center gap-2 min-h-[44px] px-4 py-2 rounded-lg border border-slate-300 ' +
      'bg-white text-navy font-semibold text-sm hover:bg-slate-50 focus-visible:ring-brand-focus">' +
      'Naar de check</button>';
    show(box);
  }

  // -------- Tabel
  function renderTable(){
    var rows = document.getElementById('vw-hist-v3-rows');
    var count = document.getElementById('vw-hist-v3-count');
    if (!rows || !count) return;
    var items = state.filtered.slice().reverse(); // nieuwste boven in tabel
    count.textContent = '(' + state.measurements.length + ')';
    rows.innerHTML = items.map(function(m){
      return '<tr class="border-b border-slate-100 hover:bg-slate-50">' +
        '<td class="p-3 text-slate-700 whitespace-nowrap text-xs">' + escapeHtml(fmtDateLong(m.measured_at)) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.pH) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.KH_dkh) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.GH_dkh) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.NO2_mg_l) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.NO3_mg_l) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.PO4_mg_l) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.NH4_total_mg_l) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.O2_mg_l) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.depth_cm) + '</td>' +
        '<td class="p-3 text-right tabular-nums">' + fmtNum(m.volume_l) + '</td>' +
        '<td class="p-3 text-right">' +
          '<button type="button" class="text-xs text-red-500 hover:underline min-h-[32px]" data-vw-delete="' + escapeHtml(m.id) + '">Verwijder</button>' +
        '</td>' +
      '</tr>';
    }).join('');
    // delete handlers
    $all('[data-vw-delete]', rows).forEach(function(btn){
      btn.addEventListener('click', function(){
        if (!confirm('Deze meting permanent verwijderen?')) return;
        var id = btn.getAttribute('data-vw-delete');
        if (lokaalModus){
          // Lokale rij: verwijderen gebeurt in localStorage, niet op de server.
          try {
            var stamp = String(id).replace(/^lokaal\|/, '');
            var lijst = JSON.parse(localStorage.getItem(LOKAAL_KEY) || '[]');
            if (Array.isArray(lijst)){
              lijst = lijst.filter(function(x){ return !x || (x.id !== stamp && x.measured_at !== stamp); });
              localStorage.setItem(LOKAAL_KEY, JSON.stringify(lijst));
            }
          } catch(_){ }
          loadLocal();
          return;
        }
        // Account: een eigen meting wissen met POST metingen/verwijder { id }. De ingang kent
        // ook DELETE metingen/:id; POST gaat in elk geval door de App Proxy.
        btn.disabled = true;
        fetch(VERWIJDER_URL, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id })
        })
          .then(leesAntwoord)
          .then(function(res){
            if (!(res.ok && res.body && res.body.ok === true)){
              meldFout(res.status === 401
                ? 'Je sessie is verlopen. Log opnieuw in om metingen te verwijderen.'
                : 'Verwijderen is niet gelukt, probeer het opnieuw.');
              btn.disabled = false;
              return null;
            }
            return fetchData();
          })
          .catch(function(){
            meldFout('Verwijderen is niet gelukt, probeer het opnieuw.');
            btn.disabled = false;
          });
      });
    });
  }

  // -------- Render-orchestratie
  function renderAll(){
    var emptyBox = document.getElementById('vw-hist-v3-empty');
    var tableWrap = document.getElementById('vw-hist-v3-table-wrap');
    var charts = document.getElementById('vw-hist-v3-charts');
    var kpis   = document.getElementById('vw-hist-v3-kpis');
    var filter = document.getElementById('vw-hist-v3-filter-wrap');

    if (!state.measurements.length){
      hide(charts); hide(tableWrap); hide(filter); hide(kpis);
      hide(document.getElementById('vw-hist-v3-nietgemeten'));
      show(emptyBox);
      return;
    }
    hide(emptyBox); show(charts); show(tableWrap); show(filter); show(kpis);

    renderKPIs();
    renderCharts();
    renderTable();
  }

  function renderError(msg){
    var box = document.getElementById('vw-hist-v3-error');
    if (!box) return;
    box.textContent = msg;
    show(box);
    hide(document.getElementById('vw-hist-v3-charts'));
    hide(document.getElementById('vw-hist-v3-table-wrap'));
    hide(document.getElementById('vw-hist-v3-empty'));
    hide(document.getElementById('vw-hist-v3-nietgemeten'));
    hide(document.getElementById('vw-hist-v3-lokaal'));
  }

  // Een foutmelding boven de historie, zonder de rest weg te halen.
  function meldFout(msg){
    var box = document.getElementById('vw-hist-v3-error');
    if (!box) return;
    box.textContent = msg;
    show(box);
  }
  // 401 terwijl de winkel zegt dat je bent ingelogd: de sessie bij de App Proxy is verlopen.
  function renderLoginFout(){
    var box = document.getElementById('vw-hist-v3-error');
    if (!box) return;
    var pad = window.location.pathname || '/pages/vijvercheck-app';
    box.innerHTML = 'Je sessie is verlopen, daardoor kunnen we je historie nu niet laden. ' +
      '<a href="/customer_authentication/login?return_to=' + encodeURIComponent(pad) + '" data-vw-lokaal-login class="underline font-semibold">Log opnieuw in</a>.';
    show(box);
    $all('[data-vw-lokaal-login]', box).forEach(function(a){ a.addEventListener('click', zetLoginIntentie); });
    hide(document.getElementById('vw-hist-v3-charts'));
    hide(document.getElementById('vw-hist-v3-table-wrap'));
    hide(document.getElementById('vw-hist-v3-empty'));
    hide(document.getElementById('vw-hist-v3-nietgemeten'));
    hide(document.getElementById('vw-hist-v3-filter-wrap'));
    hide(document.getElementById('vw-hist-v3-kpis'));
    hide(document.getElementById('vw-hist-v3-lokaal'));
    try { if (typeof window.vwTrack === 'function') window.vwTrack('vw_hist_error', { status: 401 }); } catch(_){}
  }

  // -------- Lokale strook: loginlink (16-10-2026; e-mailveld vervallen 18-10-2026, DPIA A3)
  function toonLokaalStap(stap){
    var strook = document.getElementById('vw-hist-v3-lokaal');
    if (!strook) return;
    $all('[data-vw-lokaal-stap]', strook).forEach(function(el){
      el.hidden = el.getAttribute('data-vw-lokaal-stap') !== stap;
    });
  }
  // Na het inloggen terug op de historie-tab, waar de lokale rijen vanzelf meegaan.
  function zetLoginIntentie(){
    try { localStorage.setItem('vw_post_login_action', JSON.stringify({ tab: 'historie', ts: Date.now() })); } catch(_){}
  }
  function bindLokaalLogin(){
    $all('[data-vw-lokaal-login]').forEach(function(a){
      a.addEventListener('click', zetLoginIntentie);
    });
  }

  // -------- Bootstrap
  function bootstrap(){
    bindFilter();
    bindLokaalLogin();
    var refresh = document.getElementById('vw-hist-v3-refresh');
    refresh && refresh.addEventListener('click', function(){ fetchData(); });
    // empty-state CTA: switch naar advies-tab
    document.addEventListener('click', function(ev){
      var t = ev.target.closest && ev.target.closest('[data-vw-switch-tab]');
      if (!t) return;
      var name = t.getAttribute('data-vw-switch-tab');
      var btn = document.querySelector('[data-vc-tab-btn="' + name + '"]');
      btn && btn.click();
    });
    window.addEventListener('vw-measurement-saved', function(){ setTimeout(fetchData, 600); });
    // 31-08-2026: stap 1 (bewaren op dit apparaat) moet het overzicht ook
    // bijwerken, ook als de historie-tab al eerder is gemount.
    window.addEventListener('vw-lokaal-bewaard', function(){ if (!CUSTOMER_ID) loadLocal(); });
    // 16-10-2026: de eerste fetch loopt via lazyEnsureChart (hieronder), zodat
    // er niet twee keer wordt gerenderd (een keer zonder Chart.js, met de
    // onterechte fallbackmelding, en een keer met).

    // Mobile perf (Agent 4): Chart.js pas laden bij eerste historie-tab-mount.
    // Voorheen werd Chart.js (~85KB) op DOMContentLoaded geladen, wat de
    // LCP op mobile vertraagde. Nu lazy on demand.
    var chartLibStarted = false;
    function lazyEnsureChart(){
      if (chartLibStarted) return;
      chartLibStarted = true;
      ensureChartLib().then(function(){ fetchData(); });
    }
    window.addEventListener('vw-historie-mount', lazyEnsureChart, { once: true });

    // Fallback: als historie-tab al actief is bij load (deeplink), start meteen.
    var activeHistTab = document.querySelector('[data-vc-tab-btn="historie"][aria-selected="true"]');
    if (activeHistTab) lazyEnsureChart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
